// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body > iframe {
    display: none !important;
  }
  #googoose-cover {
    position: absolute; 
    margin-bottom: 20mm;
    top: 150px;
    z-index: -1;
    width: 100%;
    text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB","sourcesContent":["body > iframe {\n    display: none !important;\n  }\n  #googoose-cover {\n    position: absolute; \n    margin-bottom: 20mm;\n    top: 150px;\n    z-index: -1;\n    width: 100%;\n    text-align: justify;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
